import { projectGraphUpdateQueryKey } from "@/api/projects";
import type { UploadOptions } from "@/hooks/useFileUpload";
import type { QueryClient } from "@tanstack/react-query";

export function invalidateUploadQueries(
  queryClient: QueryClient,
  options: UploadOptions,
) {
  void queryClient.invalidateQueries({
    queryKey: ["categories", options.mode],
  });
  void queryClient.invalidateQueries({ queryKey: ["documents"] });
  void queryClient.invalidateQueries({
    queryKey: ["documents-total-count"],
  });
  if (options.mode === "project") {
    void queryClient.invalidateQueries({
      queryKey: projectGraphUpdateQueryKey(options.instanceId),
    });
  }
}
